/** Türkçe. See `en.ts` for what each key is and what it has to fit.
 *
 * The rail glyphs stay on the Latin WMO symbols; the pressure centers take
 * the Turkish chart convention, Y / A (Yüksek / Alçak basınç), the letters
 * MGM's synoptic charts carry. Uppercase code words keep the dotted İ and
 * dotless I of Turkish casing (VERİ, KAYNAKLAR), and a percentage is written
 * with the sign before the number (%50). */

import type { MessageKey } from "./en";

export const tr: Record<MessageKey, string> = {
  metaDescription:
    "Tarayıcıda ücretsiz canlı hava durumu haritaları: GFS, ECMWF ve AIFS tahminleri, radar ve uydu animasyonları, tayfun rotaları, 3B radar ve skew-T diyagramları.",
  pageTitleLive: "{variable} tahmin haritası · {model} {hours}H",
  pageTitleLiveObservation: "{variable} gözlem haritası · {model} · son {hours} saat",
  mapAria: "Küresel sıcaklık ve yağış tahmin haritası",
  modelSwitchAria: "Veri kümesi",
  variableSwitchAria: "Hava değişkeni",
  varTemp: "2M",
  varPrecip: "ŞİDDET",
  varWind: "10M",
  varSolar: "AKI",
  varRadar: "CREF",
  varOrog: "OROG",
  varInfrared: "IR 10,4",
  varShortwave: "IR 3,9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "RENK",
  varGust: "YÜZEY",
  varCloud: "TOPLAM",
  varCape: "YÜZEY",
  varPwat: "KOLON",
  varPtype: "TÜR",
  varCin: "ENGELL",
  varHpbl: "SINIR",
  varVis: "YÜZEY",
  varDewPoint: "2M",
  varFeelsLike: "2M",
  varOmega: "DÜŞEY",
  varThetaE: "EŞDEĞ.",
  varCat: "EDR",
  varInflow: "AKIŞ",
  varFront: "CEPHE",
  varHotspot: "SICAK NOKTA",
  varFfwi: "YANGIN HAVASI",
  varFwalert: "UYARI",
  varSst: "YÜZEY",
  varIce: "ÖRTÜ",
  varWave: "BOY",
  varAod: "TOPLAM",
  varPm: "2.5",
  varDustsfc: "YÜZEY",
  varTsoil: "KATMAN 1",
  varSoilw: "KATMAN 1",
  varHumidity: "BAĞIL",
  varVapourFlux: "AKI",
  varPressure: "DENİZ",
  varHeight: "YÜKS.",
  varPressureField: "ALAN",
  varUnknownLayer: "KATMAN",

  glyphTmp2m: "T",
  glyphPrate: "R",
  glyphWind10m: "W",
  glyphDswrf: "S",
  glyphCref: "Z",
  glyphIr104: "U",
  glyphIr039: "K",
  glyphDustrgb: "T",
  glyphDustcf: "G",
  glyphZhouye: "Z",
  glyphTruecolor: "R",
  glyphGust: "G",
  glyphTcdc: "N",
  glyphCape: "C",
  glyphVis: "V",
  glyphPwat: "P",
  glyphCin: "I",
  glyphHpbl: "B",
  glyphPtype: "Y",
  glyphDpt2m: "D",
  glyphAptmp2m: "A",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "N",
  glyphFront: "C",
  glyphHotspot: "S",
  glyphFfwi: "Y",
  glyphFwalert: "U",
  glyphTmpsfc: "S",
  glyphIce: "I",
  glyphWave: "H",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "T",
  glyphTsoil: "E",
  glyphSoilw: "M",
  glyphPressure: "P",
  glyphRh: "U",
  glyphQflux: "F",
  tipTemp: "Sıcaklık",
  tipHumidity: "Bağıl nem",
  tipWind: "Rüzgar",
  tipPressure: "Basınç ve jeopotansiyel yükseklik",
  tipVapourFlux: "Su buharı akısı",
  tipCloud: "Bulutluluk",
  tipOmega: "Düşey hız",
  tipThetaE: "Eşdeğer potansiyel sıcaklık",
  tipCat: "Açık hava türbülansı",
  tipIce: "Deniz buzu",
  tipWave: "Dalgalar",
  tipAod: "Aerosol optik derinliği",
  tipPm: "Partikül madde",
  tipTsoil: "Toprak sıcaklığı",
  tipSoilw: "Toprak nemi",
  tipSatellite: "Uydu görüntüsü",
  levelSwitchAria: "Seviye",
  levelCaption: "Seviye",
  linesCaption: "Çizgiler",
  accumCaption: "Toplam",
  accumRateGloss: "yoğunluk",
  accumTotalGloss: "{window} toplam",
  modelHeading: "Veri kümeleri",
  linesRemoveTitle: "Çizgileri kaldırmak için yeniden basın",
  fieldSectionAria: "Alan",
  overlaySectionAria: "Üst katmanlar",
  markSectionAria: "İşaretler",
  tipMore: "Bu çalıştırmanın tüm katmanları",
  varMore: "Katmanlar",
  glyphMore: "+",
  fieldSheetAria: "Katmanlar",
  fieldSheetHeading: "Katmanlar",
  fieldGroupTemperature: "Sıcaklık",
  fieldGroupMoisture: "Nem",
  fieldGroupSoil: "Toprak",
  fieldGroupWind: "Rüzgar",
  fieldGroupDynamics: "Dinamik",
  fieldGroupRadiation: "Işınım ve görüş",
  fieldGroupAerosol: "Aerosoller ve hava kalitesi",
  fieldGroupOcean: "Okyanus",
  fieldGroupHydrology: "Nehirler ve taşkınlar",
  fieldGroupSatellite: "Uydu",
  fieldGroupOther: "Diğer",
  fieldGroupImagery: "Günlük görüntü: NASA GIBS",
  gibsTrueColor: "GERÇEK",
  gibsFalseColor: "YANGIN",
  gibsTipTrue: "Gerçek renk",
  gibsTipFire: "Yangın yanlış rengi: yanık alanlar koyu kırmızı",
  varParticles: "AKIŞ",
  glyphParticles: "≈",
  varVolume: "3B BULUT",
  glyphVolume: "Q",
  levelAlone: "Yalnız çizgi",
  levelAloneTitle: "Yalnız çizgiler: alan kalkar, yeniden basınca geri gelir",
  creditsTrigger: "Kaynaklar",
  creditsHeading: "Veri ve kaynaklar",
  creditsGfs: "Tahmin verisi: GFS 0.25° ve sflux",
  creditsHrrr: "Tahmin verisi: HRRR 3 km, ABD anakarası",
  creditsGefsAero: "Aerosol tahmini: GEFS-Aerosols 0,25°, AOD ve yüzey partikülleri",
  creditsCmaDust: "Toz tahmini: CMA-CW v1.0/DUST (WMO SDS-WAS Asian Center) 0,15°, Asya, WMO WIS2 üzerinden",
  creditsSilam: "Hava kalitesi tahmini: FMI SILAM v6.1 küresel 0,2°, CC BY 4.0",
  creditsCfs: "Mevsimlik tahmin: CFSv2, 9 ay, 6 saatte bir",
  creditsEcmwf: "Değiştirilmiş ECMWF verisi içerir, CC BY 4.0",
  creditsIfsHres: "ECMWF IFS'ten ECMWF tarafından uyarlandı, CC BY 4.0 ile lisanslı; Open-Meteo üzerinden; IFS HRES ~9 km, 0,1°'ye yeniden örneklendi",
  creditsMrms: "Radar gözlemleri: MRMS, ABD anakarası",
  creditsNexrad: "Tekil radar: yansıtıcılık ve radyal hız, ABD",
  creditsJma: "Radar yağışı: JMA nowcast, Japonya (yeniden ızgaralanmış)",
  creditsHimawari: "Uydu görüntüleri: Himawari-9 AHI, JMA, NOAA açık veri üzerinden (yeniden projeksiyon)",
  creditsGoes: "Uydu görüntüleri: GOES-19 Doğu ve GOES-18 Batı ABI, NOAA NESDIS, NOAA açık veri üzerinden (yeniden projeksiyon)",
  creditsMeteosat: "Uydu görüntüleri: değiştirilmiş EUMETSAT Meteosat verisi içerir {year}; Meteosat-12 FCI, saatlik döngü, CC-BY-4.0 (yeniden projeksiyon)",
  creditsSounding: "Radyosonda gözlemleri: WIS2 üzerinden GTS TEMP, ulusal meteoroloji servisleri",
  creditsAirport: "Havalimanı METAR ve TAF: dünya meteoroloji servisleri, NOAA/NWS AWC üzerinden",
  creditsFirms: "Aktif yangınlar: LANCE FIRMS NRT, VIIRS 375 m ve MODIS, NASA ESDIS",
  creditsGibs: "Günlük görüntüler: MODIS ve VIIRS düzeltilmiş yansıtma, NASA ESDIS",
  creditsRadar: "Radar mozaiği",
  creditsBasemap: "Altlık harita: © OpenStreetMap katkıda bulunanlar",
  creditsTerrain: "Kabartma: © Mapterhorn, yükseklik verisi kaynakları",
  creditsPeaks: "Zirve adları ve yükseklikleri: CC0",
  creditsCode: "Kaynak kodu: ringsaturn/xue",
  caseTag: "Vaka",
  caseSummaryAria: "Vaka özeti",
  runCycle: "Model koşusu",
  recordSpan: "Kayıt dönemi",
  latestObservation: "Son gözlem",
  latestNowcast: "Son anlık tahmin",
  awaitingData: "Veri bekleniyor",
  validTimeLabel: "Geçerlilik zamanı",
  observationTimeLabel: "Gözlem zamanı",
  statsAria: "Meraklısına istatistikler",
  statsCloseAria: "İstatistikleri kapat",
  bufferedFrames: "Arabellekte",
  downloadedBytes: "İndirilen",
  formatLabel: "Biçim",
  formatZarr: "Zarr",
  preloadProgressAria: "Tahmin verisi ön yükleme ilerlemesi",
  statDataset: "Veri seti",
  statGrid: "Grid",
  statFrameCache: "Kare önbelleği",
  statDecodeTime: "Kod çözme süresi",
  statDecodeRate: "Kod çözme hızı",
  statViewport: "Görünüm örneklemesi",
  statConnection: "Bağlantı",
  awaitingManifest: "Manifest bekleniyor",
  legendPrateAria: "Yağış şiddeti renk ölçeği",
  timelineAria: "Tahmin zaman denetimleri",
  playAnimation: "Animasyonu oynat",
  pauseAnimation: "Animasyonu duraklat",
  playbackSpeed: "Oynatma hızı",
  exportOpenAria: "Döngüyü dışa aktar",
  exportSheetAria: "Döngüyü dışa aktar",
  exportHeading: "Dışa aktar",
  exportFormat: "Biçim",
  exportSize: "Boyut",
  exportFps: "Kare hızı",
  exportRange: "Kareler",
  exportFrom: "Başlangıç",
  exportTo: "Bitiş",
  exportRun: "Dışa aktar",
  exportCancel: "İptal",
  exportSummary: "{size}, {frames} kare, {seconds} sn, yaklaşık {bytes}",
  exportCapturing: "Yakalanıyor {done}/{total}",
  exportEncoding: "Kodlanıyor %{percent}",
  exportFailed: "Dışa aktarma başarısız",
  readingManifest: "Manifest yükleniyor",
  forecastHourAria: "Tahmin saati",
  forecastDaysAria: "Günlük tahmin dilimleri",
  observationDaysAria: "Günlük dilimler",
  mapMenuAria: "Harita seçenekleri",
  menuStats: "Meraklısına istatistikler",
  menuCopyDebug: "Hata ayıklama bilgisini kopyala",
  errorTitle: "Veri kullanılamıyor",
  retry: "Yeniden dene",
  langPickerAria: "Dil",
  langPickerHeading: "Dil",
  themeToggleAria: "Açık / koyu görünümü değiştir",
  viewGlobeAria: "Küre",
  viewTerrainAria: "3B arazi",
  viewContoursAria: "Eş yükselti eğrileri",
  viewResetNorthAria: "Kuzeye sıfırla",
  viewResetPitchAria: "Eğimi sıfırla",
  viewBoxAria: "Fırtına yakın planı: bir kutu sürükleyin",
  viewSectionAria: "Düşey kesit: bir çizgi sürükleyin",
  viewDistanceAria: "Mesafe ölç: noktalara tıklayın, bitirmek için sonuncuya yeniden tıklayın",
  viewAreaAria: "Alan ölç: köşelere tıklayın, bitirmek için ilk ya da son köşeye yeniden tıklayın",
  particlesToggle: "Parçacıklar",
  particlesToggleAria: "Rüzgar parçacık animasyonunu aç/kapat",

  dataInterrupted: "Veri yükleme kesildi",
  errorHint: "{message}. make mvp çalıştırıldığından ve sayfanın make serve ile sunulduğundan emin olun.",
  loadFailed: "Yükleme başarısız",
  webglLost: "WebGL kullanılamıyor: tarayıcıdan tamamen çıkıp yeniden açın",
  saveData: "tasarruf",
  debugCopied: "Hata ayıklama bilgisi kopyalandı",
  copyFailed: "Kopyalama başarısız",
  bundleResident: "Paket tamamen arabellekte",
  viewportResident: "Görünüm tamamen arabellekte",
  streamingOnDemand: "İstek üzerine akış",
  receivingBundle: "Tahmin paketi alınıyor",
  receivingBundlePercent: "Paket alınıyor %{percent}",
  readingIndex: "Veri dizini okunuyor",
  initializingDecoder: "Kod çözücü başlatılıyor",
  framesReady: "{count} kare hazır",
  readingData: "Veri yükleniyor",
  bundleLoadFailed: "Tahmin paketi yüklenemedi",
  workerStartFailed: "Kod çözme işçisi başlatılamadı",
  decodeFailed: "Kod çözme başarısız",
  frameDecodeFailed: "Kare çözülemedi: {message}",
  legendAria: "{label} renk ölçeği",
  legendInflow: "Sıcak nemli akış",
  legendFront: "Cephe kuşağı (θe gradyanı)",
  legendHotspot: "Yangın sıcak noktası (3,9 µm bağlamsal test)",
  legendFfwi: "Fosberg yangın hava indeksi",
  legendFwalert: "Bağıl nem %30’un altında ve rüzgâr hamlesi en az 10 m/s",
  legendDustDust: "Toz",
  legendDustThickHigh: "Kalın yüksek bulut",
  legendDustThinHigh: "İnce yüksek bulut",
  legendDustMid: "Orta bulut",
  legendDustLow: "Alçak ılık bulut",
  legendDustDesert: "Sıcak çöl yüzeyi",
  legendDustSurface: "Deniz ve bitki örtülü kara",
  legendTruecolorCloud: "Bulut ve kar",
  legendTruecolorSea: "Deniz",
  legendTruecolorLand: "Kara ve bitki örtüsü",
  legendTruecolorNightCloud: "Gece bulut (kızılötesi)",
  legendTruecolorNightGround: "Gece açık gökyüzü",
  legendPtypeRain: "Yağmur",
  legendPtypeFreezingRain: "Dondurucu yağmur",
  legendPtypeSnow: "Kar",
  legendPtypeIcePellets: "Buz taneleri",
  legendDisrpBelow: "1,5 yıllık seviyenin altı",
  legendDisrp1p5: "≥ 1,5 yıllık seviye",
  legendDisrp2: "≥ 2 yıllık seviye",
  legendDisrp5: "≥ 5 yıllık seviye",
  legendDisrp20: "≥ 20 yıllık seviye",
  legendCatLight: "Hafif",
  legendCatModerate: "Orta",
  legendCatModerateSevere: "Orta–şiddetli",
  legendCatSevere: "Şiddetli",
  varLabelTmp2m: "2 m sıcaklığı",
  varLabelPrate: "Yağış şiddeti",
  varLabelDswrf: "Güneş ışınımı",
  varLabelWind10m: "10 m rüzgarı",
  varLabelWind80m: "80 m rüzgarı",
  varLabelWind100m: "100 m rüzgarı",
  varLabelCref: "Bileşik radar reflektivitesi",
  varLabelRefl3d: "3B radar yansıtıcılığı",
  varLabelCloud3d: "3B bulut suyu",
  varLabelOrog: "Orografi",
  varLabelIr104: "Kızılötesi görüntü (10,4 µm parlaklık sıcaklığı)",
  varLabelIr039: "Kısa dalga kızılötesi (3,9 µm parlaklık sıcaklığı)",
  varLabelDustrgb: "Toz RGB (kızılötesi bileşik)",
  varLabelDustcf: "DEBRA toz güveni",
  varLabelZhouye: "ZHOUYE toz güveni",
  varLabelTruecolor: "Gündüz gerçek renk, gece kızılötesi bulut",
  varLabelGust: "Rüzgar hamlesi",
  varLabelTcdc: "Toplam bulutluluk",
  varLabelCape: "Konvektif kullanılabilir potansiyel enerji",
  varLabelCin: "Konvektif engelleme",
  varLabelVis: "Görüş mesafesi",
  varLabelDpt2m: "2 m çiy noktası",
  varLabelAptmp2m: "2 m hissedilen sıcaklık",
  varLabelLcdc: "Alçak bulutluluk",
  varLabelMcdc: "Orta bulutluluk",
  varLabelHcdc: "Yüksek bulutluluk",
  varLabelPwat: "Yağışa dönüşebilir su",
  varLabelHpbl: "Gezegenel sınır tabakası yüksekliği",
  varLabelPtype: "Yağış türü",
  varLabelTmpsfc: "Deniz yüzeyi sıcaklığı (kara üzerinde yüzey sıcaklığı)",
  varLabelIcec: "Deniz buzu örtüsü",
  varLabelIcetk: "Deniz buzu kalınlığı",
  varLabelWave: "Dalgalar: belirgin dalga yüksekliği ve yönü",
  varLabelHtsgw: "Belirgin dalga yüksekliği",
  varLabelPerpw: "Birincil dalga periyodu",
  varLabelDirpw: "Birincil dalga yönü",
  varLabelWindwave: "Rüzgâr dalgası: belirgin yükseklik ve yön",
  varLabelSwell: "Ölü dalga: belirgin yükseklik ve yön (birinci bileşen)",
  varLabelWvhgt: "Rüzgâr dalgası belirgin yüksekliği",
  varLabelWvper: "Rüzgâr dalgası ortalama periyodu",
  varLabelWvdir: "Rüzgâr dalgası yönü",
  varLabelSwhgt: "Ölü dalga belirgin yüksekliği (birinci bileşen)",
  varLabelSwper: "Ölü dalga ortalama periyodu (birinci bileşen)",
  varLabelSwdir: "Ölü dalga yönü (birinci bileşen)",
  varLabelAod: "550 nm aerosol optik derinliği",
  varLabelAoddust: "Toz optik derinliği",
  varLabelAodsalt: "Deniz tuzu optik derinliği",
  varLabelAodsulf: "Sülfat optik derinliği",
  varLabelAodorg: "Organik karbon optik derinliği",
  varLabelAodbc: "Siyah karbon optik derinliği",
  varLabelPm25: "Yüzey PM2,5 derişimi",
  varLabelPm10: "Yüzey PM10 derişimi",
  varLabelPm10dust: "Yüzey toz PM10 derişimi",
  varLabelDustsfc: "Yüzey toz derişimi",
  varLabelTsoil1: "Toprak sıcaklığı, katman 1",
  varLabelTsoil2: "Toprak sıcaklığı, katman 2",
  varLabelTsoil3: "Toprak sıcaklığı, katman 3",
  varLabelTsoil4: "Toprak sıcaklığı, katman 4",
  varLabelSoilw1: "Hacimsel toprak nemi, katman 1",
  varLabelSoilw2: "Hacimsel toprak nemi, katman 2",
  varLabelSoilw3: "Hacimsel toprak nemi, katman 3",
  varLabelSoilw4: "Hacimsel toprak nemi, katman 4",
  varLabelPrmsl: "Deniz seviyesi basıncı",
  varLabelHeightAtLevel: "{level} hPa jeopotansiyel yüksekliği",
  varLabelTempAtLevel: "{level} hPa sıcaklığı",
  varLabelRhAtLevel: "{level} hPa bağıl nemi",
  varLabelSpfhAtLevel: "{level} hPa özgül nemi",
  varLabelWindAtLevel: "{level} hPa rüzgarı",
  varLabelQfluxAtLevel: "{level} hPa su buharı akısı",
  varLabelVvelAtLevel: "{level} hPa düşey hızı",
  varLabelThetaeAtLevel: "{level} hPa eşdeğer potansiyel sıcaklığı",
  varLabelCatAtLevel: "{level} hPa açık hava türbülansı (EDR)",
  legendSubtropicalHigh: "588 çizgisi",
  webglUnavailable: "Bu tarayıcı WebGL2 bağlamı sağlamıyor",
  pointerRequestFailed: "Canlı işaretçi isteği HTTP {status} döndürdü",
  manifestRequestFailed: "Manifest isteği HTTP {status} döndürdü",
  bundleRequestFailed: "Paket isteği HTTP {status} döndürdü",
  bundleTooLong: "Paket, manifestte bildirilen uzunluğu aşıyor",
  bundleLengthMismatch: "Paket uzunluğu manifestle eşleşmiyor",
  bundleChecksumMismatch: "Paket sağlama toplamı uyuşmuyor",
  bundleRunMismatch: "Paketin model koşusu manifestle eşleşmiyor",
  bundleMissingVariable: "Pakette {id} değişkeni eksik",
  manifestMissingBundle: "Manifestte {id} değişkeni için paket yok",
  mosaicNoMembers: "Mozaiğin hiçbir uydu veri kümesi kullanılamıyor",

  probeAria: "Nokta veri serisi",
  probeHint: "Seriyi doldurmak için oynatın ya da kaydırın",
  probeComplete: "Seri tamamlandı",
  probeOutside: "Bu veri setinin gridi dışında",
  probeNoData: "Bu karede veri yok",
  probeAwaiting: "Bu kare bekleniyor",
  probeModelElevationLabel: "Model",
  probeDemLabel: "DEM",
  probeCloseAria: "Nokta verisini kapat",
  cardCloseAria: "Kartı kapat",

  centerHigh: "Y",
  centerLow: "A",

  showcaseLink: "Vakalar",
  showcaseBack: "← Tüm vakalar",
  showcaseHome: "Canlı tahmin",
  showcaseTitle: "Örnek vakalar",
  showcaseHeading: "Hava olayları, yeniden oynatıldı",
  showcaseArchive: "arşiv",
  showcaseIntro:
    "Her vaka, geçmiş bir hava olayının bir kesitidir — arşivlenmiş bir tahmin koşusu ya da gözlemler — aynı kodlayıcıdan geçirilmiş, olayın yaşandığı bölgeye ve saatlere kırpılmış.",
  showcaseMetaDescription:
    "Geçmiş hava olaylarının yeniden oynatımı: tayfunlar, sağanaklar, sıcak hava dalgaları ve daha fazlası için kırpılmış tahmin ve radar veri setleri",
  showcaseLoading: "Vaka kataloğu yükleniyor",
  showcaseEmpty: "Henüz yayımlanmış vaka yok",
  showcaseLoadFailed: "Vaka kataloğu yüklenemedi: {message}",
  showcaseCaseMissing: "{id} adlı bir vaka yok",
  showcaseEventLabel: "Olay",
  showcaseRunLabel: "Koşu",
  showcaseSeriesLabel: "Başlangıç",
  showcaseRangeLabel: "Aralık",
  showcaseSpanLabel: "Süre",
  showcaseRegionLabel: "Bölge",
  showcaseGridLabel: "Grid",
  showcaseSizeLabel: "Boyut",
  showcaseVariablesLabel: "Alanlar",
  showcaseHours: "{count} sa",
  showcaseCaseAria: "{title} vakasını aç",
  showcaseListAria: "Örnek vaka listesi",

  tcTileTip: "Tropikal siklonlar",
  varTc: "ROTA",
  glyphTc: "C",
  tcSheetAria: "Tropikal siklonlar",
  tcHeading: "Tropikal siklonlar",
  tcAllSystems: "Tüm numaralı sistemler",
  tcNone: "Etkin sistem yok",
  tcUnnamed: "Adsız sistem",
  tcDisturbances: "Bozukluklar ve alçak basınçlar",
  tcPotential: "Olası sistemler",
  tcPotentialShow: "Yalnızca modellerin gördüğü {count} sistemi göster",
  tcModelOnly: "yalnızca model",
  tcAgencies: "Resmî tahminler",
  tcModels: "Model rotaları",
  tcMembers: "Topluluk üyeleri",
  tcBest: "En iyi rota",
  tcOptionsAria: "Fırtına seçenekleri",
  tcHistoryHeading: "Geçmiş tropikal siklonlar",
  tcHistoryIntro: "Arşivdeki her numaralı fırtına: merkezlerin en iyi izleri, onun için yapılan her tahmin ve her birinin ne kadar saptığı.",
  tcHistorySeasonsAria: "Sezon",
  tcHistoryBasinsAria: "Havza",
  tcHistoryAll: "Tümü",
  tcHistoryEmpty: "Bu sezon ve havzada tahmini olan fırtına yok",
  tcHistoryStormAria: "{name} aç",
  tcHistorySouthernNote: "Güney yarımküre sezonları temmuzdan hazirana sürer ve bittikleri yılla anılır: {season} sezonu {from} ile {to} arasıdır.",
  tcPageTitle: "Geçmiş tropikal siklon",
  tcPageMetaDescription: "Geçmiş bir tropikal siklon: merkezlerin en iyi izleri, onun için arşivlenen her tahmin ve her birinin ne kadar saptığı.",
  tcPageLoading: "Fırtına yükleniyor",
  tcPageMissing: "Arşivde {id} adlı fırtına yok",
  tcPageFailed: "Fırtına yüklenemedi: {message}",
  tcPageIssue: "Zaman",
  tcPageNoForecast: "bu saatten tahmin yok",
  tcPagePrev: "Önceki tahmin",
  tcPageNext: "Sonraki tahmin",
  tcPageSources: "Gösterilen izler",
  tcPageErrorsHeading: "İz hatası, km",
  tcPageTruth: "Karşılaştırılan en iyi iz",
  tcPageSource: "Kaynak",
  tcPageErrorsMean: "Fırtına boyunca ortalama",
  tcPageErrorsThis: "Haritadaki tahmin",
  tcPageErrorsNone: "Bu fırtınanın hiçbir tahmini henüz bu en iyi izle doğrulanmadı",
  tcPageNote: "Sinoptik saatlerde en iyi ize olan uzaklık, yalnızca sistem tropikal ya da subtropikal siklon olduğu sürece sayılır; bir topluluk ortalamasıyla değerlendirilir. Resmî tahminler aynı saatte başlatılan modellerle yan yana konur; bu modeller resmî tahmin yayımlandıktan sonra tamamlanmıştır.",
  tcPageId: "ATCF kimliği",
  tcPageLife: "Ömür",
  tcPagePeak: "En yüksek rüzgâr",
  tcPageForecasts: "Tahminler",
  tcCardSeasons: "Sezonlar",
  tcCardStorms: "Fırtınalar",
  tcPageDetails: "Fırtına sayfası",
  tcPageSeasonList: "Sezonun tüm fırtınaları",
  tcCardBrowse: "Sezona göre",
  tcPageRadii: "Rüzgâr yarıçapları",
  tcLegendIntensity: "Şiddet: ABD en iyi izi, 1 dk rüzgâr",

  soundingTileTip: "Radyosonda ölçümleri",
  varSounding: "YÜKSEK",
  glyphSounding: "S",
  airportTileTip: "Havalimanı gözlemleri",
  varAirport: "METAR",
  glyphAirport: "A",
  synopTileTip: "Yer meteoroloji istasyonları",
  varSynop: "YÜZEY",
  glyphSynop: "W",
  radarTileTip: "Tek istasyon radarı",
  varRadarSite: "İSTASYON",
  glyphRadarSite: "D",
  radarProductAria: "Radar ürünü",
  radarLatest: "en yeni",
  radarCloseAria: "Mozaiğe dön",
  radarReflectivity: "Yansıtırlık",
  radarVelocity: "Radyal hız",
  stationSounding: "Radyosonda",
  stationAirport: "Havalimanı",
  stationObserved: "Gözlem",
  stationFreezingLevel: "Donma seviyesi",
  stationPw: "Yağışa dönüşebilir su",
  stationCategory: "Uçuş kategorisi",
  stationVisibility: "Görüş",
  stationQnh: "QNH",
  stationLevels: "Seviye",
  stationSynop: "Meteoroloji istasyonu",
  stationHumidity: "Nem",
  stationPrecipitation: "Yağış",
  stationPressure: "İstasyon basıncı",
  stationSeaLevelPressure: "Deniz seviyesi basıncı",
  stationSunshine: "Güneşlenme",
  stationSnowDepth: "Kar derinliği",
  stationElevation: "Yükseklik",
  stationOpenSounding: "Sondajı aç",
  stationPinHere: "Buraya sabitle",
  fireTileTip: "Aktif yangınlar (NASA FIRMS, son 24 sa)",
  varFire: "YANGIN",
  glyphFire: "F",
  fireDetection: "Aktif yangın",
  fireAcquired: "Çekim",
  fireRadiativePower: "Işınım gücü",
  fireBrightness: "Parlaklık sıcaklığı",
  fireConfidence: "Güven",
  fireConfidenceLow: "düşük",
  fireConfidenceNominal: "normal",
  fireConfidenceHigh: "yüksek",
  fireOverpass: "Geçiş",
  fireDay: "gündüz",
  fireNight: "gece",
  aqTileTip: "Hava kalitesi istasyonları (PM2.5)",
  varAq: "PM2.5",
  glyphAq: "Q",
  aqStation: "Hava kalitesi",
  aqAgency: "Kurum",
  aqNetwork: "Ağ",
  aqPreliminary: "Ön veri: doğrulanmamıştır, değişebilir",
  aqDayRange: "PM2.5, son 24 sa",
  aqNearest: "En yakın hava kalitesi istasyonu, {km} km",
  alertsTileTip: "Şu an geçerli hava uyarıları",
  varAlerts: "UYARILAR",
  glyphAlerts: "!",
  alertsCardTitle: "Uyarılar",
  alertsInForceNow: "Şu an geçerli",
  alertsAsOf: "{time} itibarıyla",
  alertsLevel: "Seviye {level}",
  alertsUntilCancelled: "iptal edilene kadar",
  alertsIssued: "yayımlandı {time}",
  alertCategoryRain: "Kuvvetli yağış",
  alertCategoryFlood: "Sel",
  alertCategoryLandslide: "Heyelan",
  alertCategoryWind: "Rüzgâr",
  alertCategoryThunderstorm: "Gök gürültülü fırtına",
  alertCategorySnowIce: "Kar ve buzlanma",
  alertCategoryHeat: "Sıcak",
  alertCategoryCold: "Soğuk",
  alertCategoryFog: "Sis",
  alertCategoryDust: "Toz",
  alertCategoryFire: "Yangın riski",
  alertCategoryAir: "Hava kalitesi",
  alertCategoryCoastal: "Kıyı",
  alertCategoryMarine: "Deniz",
  alertCategoryTsunami: "Tsunami",
  alertCategoryOther: "Diğer",
  markerPlace: "Yer",
  markerEvent: "Olay",
  markerSources: "Kaynaklar",
  caseMarkersAria: "Bu vakadaki yerler ve olaylar",
  casePartsAria: "Bu olayın bölümleri",
  riverHeading: "Akarsu debisi",
  riverTracksAria: "Hidrolojik model çalıştırması",
  riverTrackAnalysis: "Analiz",
  riverTrackForecast: "Tahmin {cycle}",
  riverKeyAria: "Olağan debiye oranla debi",
  riverRatio2: "< olağanın 2×",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "Debiye göre renklendirildi, alanın ölçeğinde",
  riverExtents: "Taşkın alanları",
  riverGaugeHint: "Daireler ölçüm istasyonlarıdır: hidrografı için birine tıklayın.",
  riverObserved: "ölçülen",
  riverModelled: "model",
  riverPeaks: "Bildirilen pikler",
  riverGaugeLoading: "yükleniyor…",
  riverGaugeUnavailable: "kullanılamıyor",

  soundingObserved: "GÖZLEM",
  soundingModel: "MODEL",
  soundingNoModel: "12 sa içinde model yok",
  soundingLoading: "Sondaj okunuyor…",
  soundingUnavailable: "Sondaj kullanılamıyor",
  soundingExpand: "Tam grafik",
  soundingClose: "Kapat",
  soundingSheetHeading: "Sondaj",
  soundingSheetAria: "Sondaj grafiği",

  // The comparison page (compare.html).
  compareLink: "Karşılaştır",
  compareTitle: "Tahminleri karşılaştır",
  compareHeading: "Model karşılaştırması",
  compareEyebrow: "nokta",
  compareIntro:
    "Canlı tahmin modellerinin tümü tek bir noktada, tek bir saat üzerinde: her koşunun önümüzdeki saatler için söyledikleri, en yakın havalimanının kendi raporlarının yanında.",
  compareMetaDescription:
    "GFS, ECMWF, AIFS, IFS HRES ve HRRR tahminlerini tek bir noktada saat saat, en yakın havalimanının METAR raporlarıyla karşılaştırın.",
  compareLatitude: "Enlem",
  compareLongitude: "Boylam",
  compareLocate: "Konumumu kullan",
  compareLocateFailed: "Konum alınamadı",
  compareOnMap: "Haritada",
  compareSpan5: "5 gün",
  compareSpan15: "15 gün",
  compareFieldsAria: "Karşılaştırılacak alanlar",
  compareModelsAria: "Model karşılaştırma blokları",
  compareLoading: "{model} okunuyor…",
  compareModelFailed: "{model}: {message}",
  compareOffGrid: "bu modelin gridi dışında",
  compareNoModels: "Bu noktayı kapsayan model yok",
  compareHide: "Gizle",
  compareShow: "Göster",
  comparePin: "En üste sabitle",
  compareHidden: "Gizlenen modeller",
  compareRun: "Koşu",
  compareObservationsFrom: "{icao} raporları",
  compareNoAirport: "40 km içinde havalimanı yok",
  compareHours: "Saatler",
  compareNow: "şimdi",
  compareCells: "Her değer, o modelin kendi gridinde noktaya en yakın hücredir; enterpolasyon yapılmaz. Saatler sizin saat diliminizde okunur.",
  metricsMetaDescription: "Her Xue tahmin koşusunun ne zaman yayına girdiği, yayın iş akışlarından ölçülmüş olarak: döngü saatinden sonraki gecikme, eksik döngüler ve ERCOT gün öncesi piyasa kapanışında yayında olan koşu.",
  metricsHeading: "Koşu varışı",
  metricsEyebrow: "ölçülen",
  metricsIntro: "Her tahmin koşusunun bu sitede ne zaman yayına girdiği, yayın iş akışlarının kendi kayıtlarından: canlı işaretçinin yazıldığı an ve bunun modelin döngü saatinden ne kadar sonra olduğu.",
  metricsNotSla: "Bunlar ölçümdür, hizmet düzeyi değildir: Xue erişilebilirlik taahhüdü vermez.",
  metricsGenerated: "{time} oluşturuldu, son {days} gün",
  metricsLoading: "Ölçümler okunuyor…",
  metricsEmpty: "Henüz ölçüm yok. Ölçümler yayın iş akışlarından altı saatte bir oluşturulur; bir sonraki oluşturmadan sonra tekrar bakın.",
  metricsFailed: "Ölçümler okunamadı: {message}",
  metricsSourcesHeading: "Kaynağa göre",
  metricsLatencyNote: "Gecikme, döngü saatinden koşunun yayına girdiği ana kadardır; bu yüzden modelin kendi üretim süresini içerir. Tüm saatler UTC'dir.",
  metricsTimelineNote: "Her şerit pencerenin tamamıdır: yayına giren her döngü için döngü saatinde bir çubuk, yüksekliği kaynağın en uzununa göre gecikme; çizginin altındaki işaret hiç gelmeyen bir döngüdür.",
  metricsTypicalNote: "* Tipik kaynak süresi: modelin kendi verisinin döngü saatinden sonra genellikle ne zaman tamamlandığına dair deneyim değeri, ölçüm değildir. Olmayanlar boş bırakılır.",
  metricsTimelineAria: "Pencere boyunca {model} varışları",
  metricsCadence: "her {hours} sa",
  metricsLatest: "Son koşu",
  metricsLanded: "Yayında",
  metricsLatency: "Gecikme",
  metricsMedian: "Medyan",
  metricsMax: "Maks.",
  metricsTypical: "Tipik kaynak",
  metricsCycles: "Gelen döngüler",
  metricsMissing: "Eksik",
  metricsMissingList: "Eksik döngüler",
  metricsRuns: "İş akışı çalışmaları",
  metricsOutcomeLanded: "yayında",
  metricsOutcomeSkipped: "atlandı",
  metricsOutcomeDryRun: "deneme",
  metricsOutcomeFailed: "başarısız",
  metricsBacklog: "{count} iş akışı çalışması henüz okunmadı; bir sonraki oluşturma okur.",
  metricsDeadlinesHeading: "Son saatte",
  metricsDeadlineIntro: "Her yerel gün için son saatte zaten yayında olan en yeni koşu ve o anda döngüsünün yaşı.",
  metricsSource: "Kaynak",
  metricsCommonest: "Genelde",
  metricsNoneLive: "yok",
  glyphAurora: "A",
  varAurora: "OLASILIK",
  varDis06: "6S",
  varDisrp: "RP",
  varUpstream: "ALAN",
  fieldGroupSpace: "Uzay havası",
  fieldGroupFire: "Yangın",
  modelGroupForecast: "Tahmin modelleri",
  modelGroupRadar: "Radar",
  varLabelAurora: "Aurora görünürlük olasılığı",
  varLabelDis06: "Nehir debisi (6 saatlik ortalama)",
  varLabelDisrp: "Yineleme aralığı sınıfı",
  varLabelUpstream: "Yukarı havza alanı",
  creditsAurora: "Uzay havası: aurora olasılığı, NOAA SWPC OVATION modeli",
  creditsEfas: "Nehir debisi: Copernicus EMS EFAS v5, Avrupa 1′; yalnızca vakalar",
  creditsEra5: "Yeniden analiz: Copernicus C3S ERA5 (ECMWF), küresel 0,25°, saatlik, CC-BY-4.0; yalnızca vakalar",
  creditsCams: "Aerosol analizi: Copernicus CAMS (ECMWF), küresel 0,4°, 3 saatte bir, CC-BY-4.0; yalnızca vakalar",
};
